export default __webpack_public_path__ + "static/image6-4cd89788f4bd32c6dcfe2378a66bd5a6.gif";